module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-page', [_c('div', {
    staticClass: "top-item"
  }, [_c('div', {
    staticClass: "m-border-bottom panel-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.panelItemInfo.itemIcon,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-intro"
  }, [_c('div', {
    staticClass: "product-price"
  }, [_vm._v(_vm._s(_vm._f("currency0")(_vm.defaultPrice)))]), _vm._v(" "), _c('div', {
    staticClass: "text-two-line product-desc"
  }, [_vm._v(_vm._s(_vm.panelItemInfo.desc) + _vm._s(_vm.selectedItem))])])])]), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "action-modal"
  }, [_c('div', {
    staticClass: "combo-panel"
  }, [_c('div', {
    staticClass: "m-border-bottom combo-body combo-one"
  }, [_c('div', {
    staticClass: "combo-item"
  }, [_c('div', {
    staticClass: "combo-single"
  }, [_c('div', {
    staticClass: "combo-single-title"
  }, [_vm._v("移动支付")]), _vm._v(" "), _c('div', {
    staticClass: "combo-single-checked"
  }, [_vm._v("费率低至0.3%")])])]), _vm._v(" "), _c('div', {
    staticClass: "combo-single"
  }, [_c('div', {
    staticClass: "combo-single-title"
  }, [_vm._v("整合营销")]), _vm._v(" "), _c('div', {
    staticClass: "combo-single-checked lg-checked"
  }, [_c('span', [_vm._v("微信营销·至尊版一年 ")]), _vm._v(" | "), _c('span', [_vm._v("小程序一年")])]), _vm._v(" "), _c('div', {
    staticClass: "combo-single-checked lg-checked mr-top"
  }, [_c('span', [_vm._v("包含5000条营销短信包")])])]), _vm._v(" "), _c('div', {
    staticClass: "combo-single",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "combo-single-title"
  }, [_vm._v("行业版本一年(请选择)")]), _vm._v(" "), _c('div', {
    staticClass: "choose-box"
  }, [_c('span', {
    class: _vm.versionId === 247 ? 'version-check' : '',
    on: {
      "click": function($event) {
        _vm.chooseVersion(247)
      }
    }
  }, [_vm._v("通用零售")]), _vm._v(" "), _c('span', {
    class: _vm.versionId === 243 ? 'version-check' : '',
    on: {
      "click": function($event) {
        _vm.chooseVersion(243)
      }
    }
  }, [_vm._v("服装鞋帽")]), _vm._v(" "), _c('span', {
    class: _vm.versionId === 245 ? 'version-check' : '',
    on: {
      "click": function($event) {
        _vm.chooseVersion(245)
      }
    }
  }, [_vm._v("母婴亲子")]), _vm._v(" "), _c('span', {
    class: _vm.versionId === 255 ? 'version-check' : '',
    on: {
      "click": function($event) {
        _vm.chooseVersion(255)
      }
    }
  }, [_vm._v("宠物")]), _vm._v(" "), _c('span', {
    class: _vm.versionId === 244 ? 'version-check' : '',
    on: {
      "click": function($event) {
        _vm.chooseVersion(244)
      }
    }
  }, [_vm._v("美业丽人")]), _vm._v(" "), _c('span', {
    class: _vm.versionId === 246 ? 'version-check' : '',
    on: {
      "click": function($event) {
        _vm.chooseVersion(246)
      }
    }
  }, [_vm._v("数码电子")]), _vm._v(" "), _c('span', {
    class: _vm.versionId === 258 ? 'version-check' : '',
    on: {
      "click": function($event) {
        _vm.chooseVersion(258)
      }
    }
  }, [_vm._v("眼镜")]), _vm._v(" "), _c('span', {
    class: _vm.versionId === 242 ? 'version-check' : '',
    on: {
      "click": function($event) {
        _vm.chooseVersion(242)
      }
    }
  }, [_vm._v("餐饮")])])])]), _vm._v(" "), _c('div', {
    staticClass: "combo-body combo-two"
  }, [_c('div', {
    staticClass: "combo-item"
  }, _vm._l((_vm.productItem), function(item) {
    return _c('div', {
      staticClass: "combo-item-inline",
      on: {
        "click": function($event) {
          _vm.selectedChange(item)
        }
      }
    }, [_c('div', {
      staticClass: "item-list",
      class: [item.checked ? 'single-checked' : '']
    }, [_c('img', {
      attrs: {
        "src": item.imgSrc,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "hardware-name"
    }, [_vm._v(_vm._s(item.name))])])])
  }))])])])]), _vm._v(" "), _c('c-footer', [_c('c-button', {
    class: _vm.versionId === 0 ? 'no-checked' : '',
    nativeOn: {
      "click": function($event) {
        _vm.orderConfirm($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc233f62","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/2018-05-18/real-sale/action-modal/index.vue
// module id = 1074
// module chunks = 2